import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  GET_OPENING_STOCK,
  GET_STATIONARY,
  GET_STATIONARY_LOGS,
} from '../graphql/stationary-log.query';
import {
  CREATE_STATIONARY_LOG,
  UPDATE_STATIONARY_LOG,
} from '../graphql/stationary-log.mutation';

@Injectable({
  providedIn: 'root',
})
export class StationaryLogService {
  constructor(private apollo: Apollo) {}

  fetchStationaryItems(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_STATIONARY,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.stationories || []));
  }

  getOpeningStock(stationoryId: number, date: string): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_OPENING_STOCK,
        variables: { stationoryId, date },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.getOpeningStock || null));
  }

  fetchStationaryLogs(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_STATIONARY_LOGS,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.stationoryLogs || []));
  }

  createStationaryLog(createStationoryLogInputs: any[]): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_STATIONARY_LOG,
      variables: {
        createStationoryLogInputs,
      },
    });
  }

  updateStationaryLog(updateStationoryLogInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_STATIONARY_LOG,
      variables: {
        updateStationoryLogInput: updateStationoryLogInput,
      },
    });
  }
}
